import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';
import footsteps from 'assets/Health/footseps.png';
import { media } from 'components/responsive';
const messages = defineMessages({
    mail: 'To set up a trial in your region contact',
});
const Partner = () => {
    return (_jsx(_Fragment, { children: _jsxs(Layout, { children: [_jsx(Mail, { children: _jsxs(Text, { children: [_jsx(FormattedMessage, Object.assign({}, messages.mail)), ' ', _jsx(MailLink, { href: "mailto:health@sweatco.in", children: "health@sweatco.in" })] }) }), _jsx(Footsteps, { src: footsteps, alt: "footsteps" })] }) }));
};
const Layout = styled.div `
  border-radius: 50px;
  padding: 40px 16px;
  margin: 0 16px 100px 16px;
  flex-direction: column-reverse;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  background: linear-gradient(159deg, rgba(163, 126, 247, 0.5) 2.48%, rgba(255, 255, 255, 0.3) 101.41%);

  ${media.desktop `
    flex-direction: row;
    padding: 50px 90px 35px;
  `};
`;
const Mail = styled.div `
  display: flex;
  flex-direction: column;
  max-width: 400px;

  ${media.desktop `
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 46px;
    margin-top: 0;
  `};
`;
const Footsteps = styled.img `
  object-fit: contain;
  width: 40%;
`;
const Text = styled.p `
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  color: #5e2394;
  line-height: 1.25;

  ${media.desktop `
    font-size: 48px;
    line-height: 50px;
  `};
`;
const MailLink = styled.a `
  text-decoration: none;
`;
export default Partner;
